export default "__VITE_ASSET__BctCW_L9__"